import React from 'react';
import PropTypes from 'prop-types';

const BillingContactInfo = ({
  billingContactEmail,
  billingContactName,
  billingContactInfoNeeded,
  setBillingContactInfoNeededOnChange,
  setField,
  validateField,
}) => {
  return (
    <form>
      <div className="billing-contact-wrapper">
        <fieldset>
          <label className="billing-contact__label" htmlFor="same_as_contact">
            <input
              type="radio"
              id="same_as_contact"
              name="billing_contact_info_needed"
              onChange={setBillingContactInfoNeededOnChange}
              checked={!billingContactInfoNeeded}
              value="false"
            />
            Same as contact information
          </label>
          <label className="billing-contact__label" htmlFor="different_billing_contact">
            <input
              type="radio"
              id="different_billing_contact"
              name="billing_contact_info_needed"
              onChange={setBillingContactInfoNeededOnChange}
              checked={billingContactInfoNeeded}
              value="true"
            />
            Use a different billing contact
          </label>
        </fieldset>
        {billingContactInfoNeeded
        && (
          <div>
            <div>
              <label htmlFor="id_billing_contact_name">
                <div className="payment-info-label">Billing contact name:</div>
                <span className="form__required-tag">*</span>
                <input
                  type="text"
                  name="billingContactName"
                  id="id_billing_contact_name"
                  className={(billingContactName.touched && !billingContactName.valid) ? 'form-error__highlight' : null}
                  onBlur={validateField}
                  onChange={setField}
                  value={billingContactName.value}
                />
                {(billingContactName.touched && !billingContactName.valid) && <p className="form-error__message">{billingContactName.errors[0]}</p>}
              </label>
            </div>
            <div>
              <label htmlFor="id_billing_contact_email">
                <div className="payment-info-label">Email address for billing messages:</div>
                <span className="form__required-tag">*</span>
                <input
                  type="text"
                  name="billingContactEmail"
                  id="id_billing_contact_email"
                  className={(billingContactEmail.touched && !billingContactEmail.valid) ? 'form-error__highlight' : null}
                  onBlur={validateField}
                  onChange={setField}
                  value={billingContactEmail.value}
                />
                {(billingContactEmail.touched && !billingContactEmail.valid) && <p className="form-error__message">{billingContactEmail.errors[0]}</p>}
              </label>
            </div>
          </div>
        )}
      </div>
    </form>
  );
};

BillingContactInfo.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  billingContactName: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  billingContactEmail: PropTypes.object.isRequired,
  billingContactInfoNeeded: PropTypes.bool.isRequired,
  setBillingContactInfoNeededOnChange: PropTypes.func.isRequired,
  setField: PropTypes.func.isRequired,
  validateField: PropTypes.func.isRequired,
};

export default BillingContactInfo;
